export const iconFontAwesomeEmojiFaceKissBeam = (
	<i className="fa-solid fa-face-kiss-beam"></i>
);
